import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Chip, Divider, Grid, Paper, Tab, Tabs, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
import Global from '../../../customlib/Global';

class CheckpointReportMobile extends Component {
    state = { } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Checkpoint"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                        <Box>
                            <ToggleButtonGroup
                                color="secondary"
                                value={this.props.shift}
                                exclusive
                                onChange={this.props.handleChangeShift}
                                aria-label="Shift"
                                fullWidth
                            >
                                <ToggleButton value="PAGI">Pagi</ToggleButton>
                                <ToggleButton value="SIANG">Siang</ToggleButton>
                                <ToggleButton value="MALAM">Malam</ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                    </Filter>
                    {
                    this.props.contactLeads.map((lead, index) => {
                        return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Box key={`itemleads-${index}`}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <Typography component="span">{lead.userName}</Typography>
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                {lead.userType}
                                            </Grid>
                                            <Grid item xs={6} textAlign={"left"} sx={{pr: "5px"}}>
                                                Checkpoint: {lead.checkPointCount} times
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                Achievement : {lead.targetPercent}%
                                            </Grid>
                                            <Grid item xs={12} textAlign={"center"} sx={{pr: "5px"}}>
                                                <Chip label={lead.appLabel} variant="outlined" color='primary' />
                                                
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        lead.detail.map((historyRow, index) => {
                                            return (
                                                <Paper elevation={0} sx={{mb: "0px", padding: "5px"}}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={6}>
                                                            Is Notified :  {historyRow.isNotified === true ? "Yes" : "Not Yet"}
                                                        </Grid>
                                                        <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {
                                                                historyRow.notifiedAt !== null ? Global.formatDateTimeToStrDateTime24(historyRow.notifiedAt) : "-"
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={6}>
                                                            {
                                                                historyRow.isNotified && historyRow.checkPointSucceeded ? "Succeed" : 
                                                                historyRow.isNotified && !historyRow.checkPointSucceeded ? "Missed" : 
                                                                !historyRow.isNotified ? "-" : ""
                                                            }
                                                        </Grid>
                                                        <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {
                                                                historyRow.checkedAt !== null ? Global.formatDateTimeToStrDateTime24(historyRow.checkedAt) : "-"
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                </Paper>
                                            );
                                        })
                                    }
                                    
                                </AccordionDetails>
                            </Accordion>
                            
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default CheckpointReportMobile;